module.exports = __webpack_public_path__ + "static/media/WDRU2353.557f6da9.JPG";